import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaArrowRightLong } from "react-icons/fa6";
import { IoIosSearch } from "react-icons/io";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoClose } from "react-icons/io5";
import { BsCart4 } from "react-icons/bs";
import {
  FaUserCircle,
  FaFolderOpen,
  FaPaw,
  FaFileInvoice,
  FaHeadset,
  FaComments,
  FaBook,
  FaRegUser,
} from "react-icons/fa";
import CartDrawer from "../../components/CartDrawer";
import PhoneModel from "../../components/PhoneModel";
import LogoutModal from "../../components/LogoutModal";
import { SearchContext } from "../../../context/SearchContext";
import { useCart } from "../../../context/CartContext";
import { clearCredentials } from "../../../../src/features/auth/authSlice";
import { useProfile } from "../../../context/ProfileContext";

const MappingHeader = () => {
  const { getCartItemCount } = useCart();
  const cartItemCount = getCartItemCount();
  const dispatch = useDispatch();
  const { isAuthenticated, phone, name } = useSelector((state) => state.auth);
 //const { customerDetails, loader} = useProfile();

 const { displayDetails, loader, isSecondaryUser } = useProfile();  //new
const auth = useSelector((state) => state.auth || {});    //new
  const { secondaryUserInfo } = auth || {};     //new
  const [menuOpen, setMenuOpen] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);
  const [isPhoneModelOpen, setIsPhoneModelOpen] = useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

  const menuRef = useRef(null);
  const menuIconRef = useRef(null);

  const { pincode, setPincode, fetchVendors, loading } =
    useContext(SearchContext);

  const location = useLocation();
  const navigate = useNavigate();

  const showSearchAndCart = location.pathname !== "/confirm";

  const hiddenRoutes = ["/payment"];

   ///new
    // Function to get display name based on user type
  const getDisplayName = () => {
    if (loader) return "User";
    if (isSecondaryUser && displayDetails) {
      return displayDetails.name || secondaryUserInfo?.name || "User";
    }
    return displayDetails?.name || "User";
  };

  // Function to get display phone
  const getDisplayPhone = () => {
    if (loader) return "";
    if (isSecondaryUser && displayDetails) {
      return displayDetails.phone || secondaryUserInfo?.phone || "";
    }
    return displayDetails?.phone || "";
  };      

  const displayUserName = getDisplayName();  //new

  const handleLogin = () => setIsPhoneModelOpen(true);
  const closePhoneModel = () => setIsPhoneModelOpen(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuIconRef.current && menuIconRef.current.contains(event.target)) {
        return;
      }
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  const handleLogoutClick = () => {
    setIsLogoutModalOpen(true);
  };

  const confirmLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("phone");
    dispatch(clearCredentials());
    setIsLogoutModalOpen(false);
    navigate("/confirm");
  };

  const handleFetchVendors = async () => {
    const result = await fetchVendors(17);
    if (result) {
      setMenuOpen(false);
      navigate("/shop-detail", { state: { vendors: result.data || result } });
    }
  };

    useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleBusinessSignUp = () => {
    window.open("https://vendor.findlocalpetservices.com/", "_blank");
  };

  const goToMyAccount = () => {
    navigate("/records/bookings");
  };

  return (
    <div className="sticky top-0 z-10 bg-white border-b border-gray-200 shadow-md">
      <div className="py-4 px-4 sm:px-6 lg:px-16 flex justify-between items-center">
        {/* Left Section: Hamburger + Logo */}
        <div className="flex items-center gap-4">
          {/* Hamburger Button for Records Sidebar - Only visible on Records page on mobile/tablet */}
          {/* {location.pathname === "/Records" && (
            <button
              onClick={() => {
                // Dispatch custom event to toggle Records sidebar
                window.dispatchEvent(new CustomEvent("toggleRecordsSidebar"));
              }}
              className="lg:hidden p-2.5 bg-gradient-to-r from-[#FF6216] to-[#FD5901] text-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300 active:scale-95"
            >
              <GiHamburgerMenu size={24} />
            </button>
          )} */}

          {/* Logo */}
          <p
            className="font-semibold text-2xl sm:text-3xl lg:text-[44px] font-[lora] text-[#FD5901] hover:opacity-70 cursor-pointer transition-opacity"
            onClick={() => navigate("/")}
          >
            FindLocalPetServices
          </p>
        </div>

        {/* Desktop Right Section */}
        {!hiddenRoutes.includes(location.pathname) && (
          <div className="hidden lg:flex items-center gap-8">
            {/* Search */}
            {showSearchAndCart && location.pathname !== "/" && (
              <div className="relative group">
                <IoIosSearch className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 z-10 w-5 h-5 text-[#FF6216]" />

                <input
                  type="text"
                  inputMode="numeric"
                  value={pincode || ""}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, "").slice(0, 6);
                    setPincode(val);
                  }}
                  placeholder="Enter pincode"
                  className="
                    w-64 pl-12 pr-14 py-3.5
                    text-base font-medium text-gray-800 placeholder-gray-500
                    bg-white border-2 border-[#FF6216]/30 rounded-xl
                    focus:outline-none focus:border-[#FF6216] focus:ring-4 focus:ring-orange-100
                    transition-all duration-300
                  "
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && pincode?.length === 6) {
                      handleFetchVendors();
                      setMenuOpen(false);
                    }
                  }}
                />

                <button
                  onClick={handleFetchVendors}
                  disabled={loading || pincode?.length !== 6}
                  className={`
                    absolute right-2 top-1/2 -translate-y-1/2
                    w-11 h-11 rounded-lg flex items-center justify-center
                    transition-all duration-300 transform active:scale-95
                    ${
                      loading || pincode?.length !== 6
                        ? "bg-gray-300 cursor-not-allowed"
                        : "bg-[#FF6216] hover:bg-[#e05514] shadow-md hover:shadow-lg"
                    }
                    text-white
                  `}
                >
                  {loading ? (
                    <svg className="w-5 h-5 animate-spin" viewBox="0 0 24 24">
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                        fill="none"
                        className="opacity-30"
                      />
                      <path fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                    </svg>
                  ) : (
                    <FaArrowRightLong className="w-5 h-5" />
                  )}
                </button>
              </div>
            )}

            {/* User Section */}
            {isAuthenticated ? (
              <div className="flex items-center gap-8">
                {/* User Icon + Name → Direct to My Account */}
                <div
                  className="flex items-center gap-3 cursor-pointer group"
                  onClick={goToMyAccount}
                >
                  <FaUserCircle className="w-10 h-10 text-[#FD5901] group-hover:scale-110 transition-transform duration-200" />
                  <div className="text-left">
                    <p className="font-bold text-gray-800 text-lg">
                     {/* {customerDetails?.name ||
                        `${customerDetails?.firstname || customerDetails?.firstName || ""} ${
                          customerDetails?.lastname || customerDetails?.lastName || ""
                        }`.trim() ||
                        "User"}  */}
                        {displayUserName}
                    </p>
                    {/* <p className="text-sm text-gray-600">My Account →</p> */}
                  </div>
                </div>

                {/* Orange Logout Button */}
                {/* <button
                  onClick={handleLogoutClick}
                  className="
                    bg-gradient-to-r from-[#FF6216] to-[#FD5901]
                    hover:from-[#e05514] hover:to-[#e04e00]
                    text-white font-semibold px-6 py-3 rounded-xl
                    shadow-lg hover:shadow-xl
                    transition-all duration-300 transform hover:-translate-y-0.5 active:scale-95
                  "
                >
                  Logout
                </button> */}
              </div>
            ) : (
              <button
                onClick={handleLogin}
                className="text-[#000048] font-bold text-xl hover:opacity-70 transition"
              >
                Log In
              </button>
            )}

            {/* Cart */}
            {showSearchAndCart &&
              (location.pathname !== "/" || cartItemCount > 0) && (
                <button onClick={() => setCartOpen(true)} className="relative">
                  <BsCart4 className="w-8 h-8 text-[#FD5901] hover:scale-110 transition-transform" />
                  {cartItemCount > 0 && (
                    <span className="absolute -top-2 -right-2 bg-[#FF6216] text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center shadow-md">
                      {cartItemCount}
                    </span>
                  )}
                </button>
              )}

            {/* Business Sign Up */}
            {!isAuthenticated && (
              <button
                className="bg-[#FF6216] hover:bg-[#e05514] text-white font-semibold px-6 py-3 rounded-xl shadow-md hover:shadow-lg transition-all duration-300"
                onClick={handleBusinessSignUp}
              >
                Business Sign Up
              </button>
            )}
          </div>
        )}

        {/* Mobile Icons - Improved Design */}
        <div className="lg:hidden flex items-center gap-5">
          {/* Cart */}
          {showSearchAndCart &&
            (location.pathname !== "/" || cartItemCount > 0) && (
              <button onClick={() => setCartOpen(true)} className="relative">
                <BsCart4 className="w-6 h-6 text-[#FD5901]" />
                {cartItemCount > 0 && (
                  <span className="absolute -top-2 -right-2 bg-[#FF6216] text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center shadow-md">
                    {cartItemCount}
                  </span>
                )}
              </button>
            )}

          {/* Premium Hamburger Button */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            ref={menuIconRef}
            className="
              p-2 
              bg-gradient-to-r from-[#FF6216] to-[#FD5901] 
              text-white 
              rounded-xl 
              shadow-lg hover:shadow-xl 
              transition-all duration-300 
              active:scale-95 
              flex items-center justify-center
            "
          >
            {menuOpen ? (
              <IoClose className="w-7 h-7" />
            ) : (
              <GiHamburgerMenu className="w-6 h-6" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu - Enhanced UI */}
      {menuOpen && !hiddenRoutes.includes(location.pathname) && (
        <div
          className="lg:hidden px-6 pb-6 pt-4 bg-white border-t-2 border-orange-100"
          ref={menuRef}
        >
          <div className="space-y-5">
            {/* Improved Mobile Search */}
            {showSearchAndCart && location.pathname !== "/" && (
              <div className="relative">
                <IoIosSearch className="absolute left-5 top-1/2 -translate-y-1/2 w-6 h-6 text-[#FF6216]" />
                <input
                  type="text"
                  inputMode="numeric"
                  value={pincode || ""}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, "").slice(0, 6);
                    setPincode(val);
                  }}
                  placeholder="Enter your pincode"
                  className="
                    w-full pl-14 pr-16 py-4
                    text-lg font-medium text-gray-800 placeholder-gray-500
                    bg-gray-50 border-2 border-[#FF6216]/40 rounded-2xl
                    focus:outline-none focus:border-[#FF6216] focus:bg-white focus:ring-4 focus:ring-orange-100
                    transition-all duration-300
                  "
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && pincode?.length === 6) {
                      handleFetchVendors();
                    }
                  }}
                />
                <button
                  onClick={handleFetchVendors}
                  disabled={loading || pincode?.length !== 6}
                  className={`
                    absolute right-3 top-1/2 -translate-y-1/2
                    w-12 h-12 rounded-xl flex items-center justify-center
                    transition-all duration-300 active:scale-90
                    ${
                      loading || pincode?.length !== 6
                        ? "bg-gray-300"
                        : "bg-gradient-to-r from-[#FF6216] to-[#FD5901] shadow-lg"
                    }
                  `}
                >
                  {loading ? (
                    <svg
                      className="w-6 h-6 animate-spin text-white"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                        fill="none"
                        className="opacity-30"
                      />
                      <path fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                    </svg>
                  ) : (
                    <FaArrowRightLong className="w-6 h-6 text-white" />
                  )}
                </button>
              </div>
            )}

            {/* Authenticated User */}
            {isAuthenticated ? (
              <div className="space-y-4">
                {/* Mobile Menu Items */}
                <div className="flex flex-col gap-2">
                  {[
                    {
                      name: "Profile",
                      icon: <FaRegUser />,
                      path: "/records/profile",
                    },
                    {
                      name: "My Bookings",
                      icon: <FaFolderOpen />,
                      path: "/records/bookings",
                    },
                    {
                      name: "My Pets",
                      icon: <FaPaw />,
                      path: "/records/pets",
                    },
                    {
                      name: "Diary",
                      icon: <FaBook />,
                      path: "/records/diary",
                    },
                    // {
                    //   name: "Invoice",
                    //   icon: <FaFileInvoice />,
                    //   path: "/records/invoice",
                    // },
                   // {
                    //  name: "Chats",
                     // icon: <FaComments />,
                    //  path: "/records/chats",
                   // },
                    {
                      name: "Contact Us",
                      icon: <FaHeadset />,
                      path: "/records/contact",
                    },
                    
                  ].map((item) => (
                    <button
                      key={item.name}
                      onClick={() => {
                        navigate(item.path);
                        setMenuOpen(false);
                      }}
                      className="
                        w-full flex items-center gap-4 px-6 py-4
                        bg-gray-50 hover:bg-orange-50
                        rounded-xl transition-all duration-300
                      "
                    >
                      <span className="text-xl text-[#FF6216]">
                        {item.icon}
                      </span>
                      <span className="font-medium text-gray-800 text-lg">
                        {item.name}
                      </span>
                    </button>
                  ))}
                </div>

                {/* Orange Logout Button */}
                <button
                  onClick={handleLogoutClick}
                  className="
                    w-full py-4
                    bg-gradient-to-r from-[#ed6b2a] to-[#d45c1c]
                    hover:from-[#e05514] hover:to-[#e04e00]
                    text-white font-bold text-lg rounded-2xl
                    shadow-xl hover:shadow-2xl
                    transition-all duration-300 active:scale-95
                  "
                >
                  Logout
                </button>
              </div>
            ) : (
              <button
                onClick={() => {
                  handleLogin();
                  setMenuOpen(false);
                }}
                className="
                  w-full py-4
                  bg-white text-[#FF6216] border-2 border-[#FF6216]
                  hover:bg-[#FF6216] hover:text-white
                  font-bold text-lg rounded-2xl
                  transition-all duration-300 shadow-md hover:shadow-xl
                "
              >
                Log In
              </button>
            )}

            {/* Business Sign Up (if not logged in) */}
            {!isAuthenticated && (
              <button
                className="
                  w-full py-4
                  bg-gradient-to-r from-[#FF6216] to-[#FD5901]
                  hover:from-[#e05514] hover:to-[#e04e00]
                  text-white font-bold text-lg rounded-2xl
                  shadow-xl hover:shadow-2xl transition-all duration-300
                "
                onClick={handleBusinessSignUp}
              >
                Business Sign Up
              </button>
            )}
          </div>
        </div>
      )}

      {/* Modals & Drawers */}
      {cartOpen && (
        <CartDrawer isOpen={cartOpen} onClose={() => setCartOpen(false)} />
      )}
      <PhoneModel isOpen={isPhoneModelOpen} closeModal={closePhoneModel} />
      <LogoutModal
        isOpen={isLogoutModalOpen}
        onClose={() => setIsLogoutModalOpen(false)}
        onLogout={confirmLogout}
      />
    </div>
  );
};

export default MappingHeader;
